<template>
  <ul :class="parentClass" class="list-unstyled account-links mb-0">
    <template v-if="$page.props.auth.user.linked_session && $page.props.auth.user.linked_session.linked.length > 0">


      <jet-dropdown-link :href="route('mtd.enduseaslinked', $page.props.auth.user.id)">
        <p class="mb-1 small text-muted pt-2 border-top px-3">{{ $page.props.auth.user.linked_session.user.company_name }} Account</p>
      </jet-dropdown-link>

      <template v-for="linked in $page.props.auth.user.linked_session.linked">
        <jet-dropdown-link :href="route('mtd.useaslinked', linked.id)">
          <i class="fa fa-check-circle" v-if="$page.props.auth.user.id == linked.id"></i> 
          <i class="fas fa-sign-in-alt" v-else></i> 
          {{ linked.company_name }}
        </jet-dropdown-link>
      </template>

    </template>
    <jet-dropdown-link :active="$page.url.startsWith('/mtd/wholesale')" :href="route('mtd.wholesale')" v-if="isMtd()">
      Wholesale Store
    </jet-dropdown-link>

    <hr v-if="isMtd()"/>

    <jet-dropdown-link :active="$page.url.startsWith('/shop/user/profile')" :href="route('mtn.profile.show')">
      Profile &amp; Settings
    </jet-dropdown-link>

    <jet-dropdown-link :active="$page.url.startsWith('/mtd/orders')" :href="route('mtd.orders.list')" v-if="isMtd()">
      Order History
    </jet-dropdown-link>

    <jet-dropdown-link :active="$page.url.startsWith('/shop/user/orders')" :href="route('orders.list')" v-if="isTu()">
      Order History
    </jet-dropdown-link>

    <jet-dropdown-link :active="$page.url.startsWith('/shop/user/payments')" :href="route('payments.list')" v-if="isTu()">
      Payments
    </jet-dropdown-link>

    <jet-dropdown-link :active="$page.url == '/mtd/returns'" :href="route('mtd.return.index')" v-if="isMtd()">
      Returns & Warranty
    </jet-dropdown-link>

    <jet-dropdown-link :active="$page.url.startsWith('/shop/shipments')" :href="route('shipments.list')">
      Shipments
    </jet-dropdown-link>
    
    <hr v-if="isMtd()"/>

    <jet-dropdown-link :active="$page.url.startsWith('/mtd/billing')" :href="route('mtd.billing', 'charges')" v-if="isMtd()">
      Account Billing
    </jet-dropdown-link>

    <jet-dropdown-link :active="$page.url.startsWith('/mtd/account-finance')" :href="route('mtd.history')" v-if="isMtd()">
      Account Finance
    </jet-dropdown-link>

    <jet-dropdown-link :active="$page.url.startsWith('/mtd/account-activity-report')" :href="route('mtd.report')" v-if="isMtd()">
      Account Activity
    </jet-dropdown-link>
    
    <hr v-if="isMtd()"/>
    <jet-dropdown-link :active="$page.url.startsWith('/mtd/catalog')" :href="route('catalog')" v-if="isMtd()">
      Product Settings
    </jet-dropdown-link>

    <jet-dropdown-link :active="$page.url.startsWith('/mtd/products')" :href="route('mtd.products')" v-if="isMtd()">
      My Products
    </jet-dropdown-link>

    <jet-dropdown-link :active="$page.url.startsWith('/mtd/payout-settings')" :href="route('payout')" v-if="isMtd()">
      Payout Settings
    </jet-dropdown-link>

    <jet-dropdown-link :active="$page.url.startsWith('/mtd/videos')" :href="route('mtd.videos')" v-if="isMtd()">
      Training Videos
    </jet-dropdown-link>

    <slot></slot>

  </ul>
</template>

<script>
  import JetDropdownLink from '@/Jetstream/DropdownLink'
  import JetNavLink from '@/Jetstream/NavLink'

  export default {
    components: {
      JetDropdownLink,
      JetNavLink
    },
    props: {
      parentClass: String,
      mobileMenu: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style>
  .account-links hr {
    margin: .3rem;
  }

  .account-links a {
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
